import { SearchIcon } from "lucide-react";
import "./index.css"
import { FormControl } from "react-bootstrap";
const TableSearch = ({ value, onChange, onClear, coverClass = "", ...rest }) => {
    return (
        <div className={`search-input-wrapper ${coverClass}`}>
            <SearchIcon size={20} className="search-icon" />
            <FormControl
                type="search"
                value={value}
                onChange={onChange}
                {...rest}
            />
            {value && (
                <button
                    className="search-clear-btn"
                    onClick={onClear}
                    title="Clear search"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            )}
        </div>
    )
}
export { TableSearch }